const PREFIX = "donation_";

class LocalStorageUtil {
  static set(key, value) {
    try {
      if (typeof value === "object") {
        localStorage.setItem(key, JSON.stringify(value));
      } else {
        localStorage.setItem(key, value);
      }
    } catch (error) {
      console.error("LocalStorage SET Error:", error);
    }
  }

  static isUsableObject(value) {
    return (
      value !== null &&
      typeof value === "object" &&
      Object.keys(value).length > 0
    );
  }

  static get(key) {
    try {
      const value = localStorage.getItem(key);

      if (value === null || value === undefined) {
        return null;
      }

      try {
        return JSON.parse(value);
      } catch {
        return value;
      }
    } catch (error) {
      console.error("LocalStorage GET Error:", error);
      return null;
    }
  }

  static remove(key) {
    localStorage.removeItem(key);
  }

  static clear() {
    localStorage.clear();
  }

  static saveAd(adData) {
    this.set(`${PREFIX}ad`, adData);
  }

  static getAd() {
    return this.get(`${PREFIX}ad`);
  }

  static savePixel(pixel) {
    this.set(`${PREFIX}pixel`, pixel);
  }

  static getPixel() {
    return this.get(`${PREFIX}pixel`);
  }

  static saveFbqToken(token) {
    this.set(`${PREFIX}fbqToken`, token);
  }

  static getFbqToken() {
    return this.get(`${PREFIX}fbqToken`);
  }

  static saveTgid(tgid) {
    this.set(`${PREFIX}tgid`, tgid);
  }

  static getTgid() {
    return this.get(`${PREFIX}tgid`);
  }

  static saveGroupId(groupId) {
    this.set(`${PREFIX}group_id`, groupId);
  }

  static getGroupId() {
    return this.get(`${PREFIX}group_id`);
  }

  static genUserId() {
    const ch =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let r = "";
    for (let i = 0; i < 6; i++)
      r += ch[Math.floor(Math.random() * ch.length)];
    return r;
  }

  static getUserId() {
    let userid = this.get("userid");
    if (!userid) {
      userid = this.genUserId();
      this.set("userid", userid);
    }
    return userid;
  }

  static saveSiteInfo(siteInfo) {
    if (!this.isUsableObject(siteInfo)) {
      console.warn("LocalStorageUtil.saveSiteInfo: siteInfo 无效，已忽略", siteInfo);
      return;
    }
    this.set(`${PREFIX}site_info`, siteInfo);
  }

  static getSiteInfo(fallback = null) {
    const siteInfo = this.get(`${PREFIX}site_info`);
    if (this.isUsableObject(siteInfo)) {
      return siteInfo;
    }
    return fallback;
  }
}

export default LocalStorageUtil;
